import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import { rolesOf } from '@volee/api-client'

import { mustReadTheAutonomyNotice } from '../auth/guard.ts'
import { loadMe } from '../auth/me.ts'
import { profileFor } from '../auth/profile.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'
import { parseReturnTo } from './sign-in.tsx'

// «Da oggi decidi tu»: where `guardRoute` sends a player who turned 14 after a tutela, before any page.
// Bare, as the waiting page: nothing of the app is reachable until the step is done.

export interface AutonomySearch {
  readonly returnTo?: string
}

export const autonomyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.autonomy,
  staticData: { chrome: 'bare' },
  validateSearch: (search: Record<string, unknown>): AutonomySearch => ({
    returnTo: search.returnTo === undefined ? undefined : parseReturnTo(search.returnTo),
  }),
  beforeLoad: async ({ context, location, search }) => {
    const me = await loadMe(context.queryClient)
    if (me === null) {
      throw redirect({
        to: NAV_PATHS.signIn,
        search: { returnTo: location.href, reason: 'required' },
      })
    }
    if (!mustReadTheAutonomyNotice(me)) {
      throw redirect({ to: search.returnTo ?? profileFor(rolesOf(me)) ?? NAV_PATHS.forbidden })
    }
  },
  component: lazyRouteComponent(() => import('../pages/autonomy.tsx')),
})
